/* eslint-disable */

export default function setNavPills() {
  // nav-pills 요소 모두 조회 (실행 시점에 맞게 항상 최신 노드셋을 가져오기 위해 함수 내부에서 조회)
  function getNavPills() {
    return document.querySelectorAll('.nav-pills');
  }

  // 이벤트 타겟 추출 함수
  function getEventTarget(e) {
    e = e || window.event;
    return e.target || e.srcElement;
  }

  // 초기 생성 및 마우스오버 이벤트 등록
  function initNavs() {
    const total = getNavPills();

    total.forEach(function (item) {
      // 기존 moving-tab 제거(중복 방지)
      const oldMovingTab = item.querySelector('.moving-tab');
      if (oldMovingTab) oldMovingTab.remove();

      // 첫 li 의 nav-link 복사해서 moving-tab 생성
      const firstLink = item.querySelector('li:first-child .nav-link');
      if (!firstLink) return;

      const movingDiv = document.createElement('div');
      const tab = firstLink.cloneNode(true);
      tab.innerHTML = "-";

      movingDiv.classList.add('moving-tab', 'position-absolute', 'nav-link');
      movingDiv.style.padding = '0px';
      movingDiv.style.transition = '.5s ease';
      movingDiv.appendChild(tab);
      item.appendChild(movingDiv);

      // 초기 위치와 크기 설정
      movingDiv.style.width = item.querySelector('li:nth-child(1)').offsetWidth + 'px';
      movingDiv.style.transform = 'translate3d(0px, 0px, 0px)';

      // 마우스 오버 이벤트 등록
      item.onmouseover = function (event) {
        let target = getEventTarget(event);
        let li = target.closest('li');
        if (!li) return;

        let nodes = Array.from(li.closest('ul').children);
        let index = nodes.indexOf(li) + 1;

        // 클릭 이벤트 등록: 클릭 시 이동 효과 적용
        item.querySelector('li:nth-child(' + index + ') .nav-link').onclick = function () {
          const moving_div = item.querySelector('.moving-tab');
          if (!moving_div) return;

          let sum = 0;
          if (item.classList.contains('flex-column')) {
            for (let j = 1; j <= nodes.indexOf(li); j++) {
              sum += item.querySelector('li:nth-child(' + j + ')').offsetHeight;
            }
            moving_div.style.transform = 'translate3d(0px,' + sum + 'px, 0px)';
            moving_div.style.height = item.querySelector('li:nth-child(' + index + ')').offsetHeight + 'px';
          } else {
            for (let j = 1; j <= nodes.indexOf(li); j++) {
              sum += item.querySelector('li:nth-child(' + j + ')').offsetWidth;
            }
            moving_div.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)';
            moving_div.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
          }
        }
      }
    });
  }

  // 윈도우 크기 변경 시 moving-tab 위치 및 크기 조정 함수
  function updateMovingTabs() {
    const total = getNavPills();

    total.forEach(function (item) {
      // 기존 moving-tab 제거 후 재생성
      const oldMovingTab = item.querySelector('.moving-tab');
      if (oldMovingTab) oldMovingTab.remove();

      const activeLink = item.querySelector(".nav-link.active");
      if (!activeLink) return;

      const movingDiv = document.createElement('div');
      const tab = activeLink.cloneNode(true);
      tab.innerHTML = "-";

      movingDiv.classList.add('moving-tab', 'position-absolute', 'nav-link');
      movingDiv.style.padding = '0px';
      movingDiv.style.transition = '.5s ease';
      movingDiv.appendChild(tab);
      item.appendChild(movingDiv);

      let li = activeLink.parentElement;
      if (!li) return;

      let nodes = Array.from(li.closest('ul').children);
      let index = nodes.indexOf(li) + 1;

      let sum = 0;
      if (item.classList.contains('flex-column')) {
        for (let j = 1; j <= nodes.indexOf(li); j++) {
          sum += item.querySelector('li:nth-child(' + j + ')').offsetHeight;
        }
        movingDiv.style.transform = 'translate3d(0px,' + sum + 'px, 0px)';
        movingDiv.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
        movingDiv.style.height = item.querySelector('li:nth-child(' + index + ')').offsetHeight + 'px';
      } else {
        for (let j = 1; j <= nodes.indexOf(li); j++) {
          sum += item.querySelector('li:nth-child(' + j + ')').offsetWidth;
        }
        movingDiv.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)';
        movingDiv.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
      }
    });

    // 모바일 크기별 flex-row/column 처리
    if (window.innerWidth < 991) {
      total.forEach(function (item) {
        if (!item.classList.contains('flex-column')) {
          item.classList.remove('flex-row');
          item.classList.add('flex-column', 'on-resize');
          const li = item.querySelector(".nav-link.active")?.parentElement;
          if (!li) return;

          const nodes = Array.from(li.closest('ul').children);
          let sum = 0;
          for (let j = 1; j <= nodes.indexOf(li); j++) {
            sum += item.querySelector('li:nth-child(' + j + ')').offsetHeight;
          }
          const movingDiv = item.querySelector('.moving-tab');
          if (!movingDiv) return;

          movingDiv.style.width = item.querySelector('li:nth-child(1)').offsetWidth + 'px';
          movingDiv.style.transform = 'translate3d(0px,' + sum + 'px, 0px)';
        }
      });
    } else {
      total.forEach(function (item) {
        if (item.classList.contains('on-resize')) {
          item.classList.remove('flex-column', 'on-resize');
          item.classList.add('flex-row');

          const li = item.querySelector(".nav-link.active")?.parentElement;
          if (!li) return;

          const nodes = Array.from(li.closest('ul').children);
          let sum = 0;
          for (let j = 1; j <= nodes.indexOf(li); j++) {
            sum += item.querySelector('li:nth-child(' + j + ')').offsetWidth;
          }
          const movingDiv = item.querySelector('.moving-tab');
          if (!movingDiv) return;

          movingDiv.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)';
          movingDiv.style.width = item.querySelector('li:nth-child(' + (nodes.indexOf(li) + 1) + ')').offsetWidth + 'px';
        }
      });
    }
  }

  // 모바일 초기 flex 조정
  function initMobileFlex() {
    const total = getNavPills();
    if (window.innerWidth < 991) {
      total.forEach(function (item) {
        if (item.classList.contains('flex-row')) {
          item.classList.remove('flex-row');
          item.classList.add('flex-column', 'on-resize');
        }
      });
    }
  }

  // 초기화
  setTimeout(() => {
    initNavs();
    updateMovingTabs();
    initMobileFlex();
  }, 100);

  // 이벤트 등록
  window.addEventListener('resize', function () {
    updateMovingTabs();
  });
}
